// TODO: swap with selectShowAdditionalContent script
export const otherFieldsListener = () => {
    const otherFields = [...document.querySelectorAll('.js-poll-other-field')].filter(
        (el) => !el.dataset.otherFieldInitialized
    );

    otherFields.forEach((field) => {
        const otherFieldElementsToShow = document.querySelectorAll(
            `.js-poll-other-field-show[data-other-field-show="${field.dataset.otherFieldShow}"]`
        );

        field.addEventListener('change', () => {
            if (field.options[field.selectedIndex]?.dataset.value === 'other') {
                otherFieldElementsToShow.forEach((el) => {
                    el.classList.remove('d-none');
                });
            }
        });

        field.dataset.otherFieldInitialized = true;
    });
};
